/* unplugin-vue-components disabled */import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import useList from './hooks/useList';
import useConfirmRelease from './hooks/useConfirmRelease';
import MaterialItem from './cpns/MaterialItem.vue';
import localCache from '@/utils/localCache';
import { showToast } from 'vant';
export default defineComponent({
  name: 'SelectWarehouse',
  components: {
    MaterialItem: MaterialItem
  },
  setup: function setup() {
    // const formatDate = (date: Date) => {
    //   return dayjs(date).format('YYYY/MM/DD');
    // };
    var route = useRoute();
    var router = useRouter();
    if (route.params.release_no) {
      localCache.setItem('release_no', route.params.release_no);
    }
    var params = ref({
      release_no: localCache.getItem('release_no')
    });
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            getReleaseListAsync();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var onSearch = function onSearch() {
      getReleaseListAsync();
    };
    var tabs = ref([{
      name: '所有',
      value: ''
    }, {
      name: '已领',
      value: '1'
    }, {
      name: '未领',
      value: '0'
    }]);
    var tabActive = ref(0);
    var _useList = useList(params, tabActive),
      _useList2 = _slicedToArray(_useList, 4),
      detail = _useList2[0],
      list = _useList2[1],
      finished = _useList2[2],
      getReleaseListAsync = _useList2[3];
    var tabClick = function tabClick(item, index) {
      tabActive.value = index;
      getReleaseListAsync();
    };
    var statusFormat = function statusFormat(status) {
      // 出库审核状态：0未审核 1审核中  2 待出库 3已驳回  4已出库
      var text = '';
      switch (status) {
        case 0:
          text = '未审核';
          break;
        case 1:
          text = '审核中';
          break;
        case 2:
          text = '待出库';
          break;
        case 3:
          text = '已驳回';
          break;
        case 4:
          text = '已出库';
          break;
      }
      return text;
    };
    var confirm = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              console.log('confirm');
              if (!detail.value.doing_slave.length) {
                _context2.next = 4;
                break;
              }
              showToast('您还有未领取的物料，请全部领取后出库');
              return _context2.abrupt("return");
            case 4:
              _context2.next = 6;
              return confirmReleaseAsync();
            case 6:
              res = _context2.sent;
              showToast(res.info);
              setTimeout(function () {
                router.back();
              }, 500);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function confirm() {
        return _ref2.apply(this, arguments);
      };
    }();
    var _useConfirmRelease = useConfirmRelease(params),
      _useConfirmRelease2 = _slicedToArray(_useConfirmRelease, 1),
      confirmReleaseAsync = _useConfirmRelease2[0];
    return {
      params: params,
      detail: detail,
      finished: finished,
      tabs: tabs,
      tabActive: tabActive,
      tabClick: tabClick,
      statusFormat: statusFormat,
      list: list,
      confirm: confirm,
      onSearch: onSearch
    };
  }
});